// ./src/contexts/SignupItemsContext/SignupItemsContext.tsx
//
// Thin context wrapper around the useSignupItems hook. All derived data lives in
// the hook itself. See PointsOfInterestContext for the pattern.

import React, { createContext, useContext } from "react";

import {
  useSignupItems,
  UseSignupItemsOptions,
  UseSignupItemsReturn,
} from "@/hooks/useSignupItems";

const SignupItemsContext = createContext<UseSignupItemsReturn | null>(null);

export interface SignupItemsProviderProps extends UseSignupItemsOptions {
  children: React.ReactNode;
}

export const SignupItemsProvider: React.FC<SignupItemsProviderProps> = ({ children, ...options }) => {
  const value = useSignupItems(options);

  return <SignupItemsContext.Provider value={value}>{children}</SignupItemsContext.Provider>;
};

export const useSignupItemsContext = (): UseSignupItemsReturn => {
  const context = useContext(SignupItemsContext);

  if (!context) {
    throw new Error(
      "useSignupItemsContext must be used within an <SignupItemsProvider>. " +
        "Wrap your component tree with <SignupItemsProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalSignupItemsContext = (): UseSignupItemsReturn | null => {
  return useContext(SignupItemsContext);
};
